import React, { useEffect, useRef } from "react";

export default function BackgroundVideo() {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (v) {
      v.play().catch(() => {});
    }
  }, []);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-[#0a0a0b]">
      <video
        ref={ref}
        className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover opacity-60"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src="/bg.mp4" type="video/mp4" />
      </video>
      {/* Readability overlays */}
      <div className="absolute inset-0 bg-[#0a0a0b]/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/30 via-[#0a0a0b]/15 to-[#0a0a0b]/75" />
    </div>
  );
}
